import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import { DefaultsContext } from 'features/globalSetup/pages/Defaults/DefaultsContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { Form } from './Form'
import { useUpdateWorkspaceGeneralConfiguration } from './hooks/useUpdateWorkspaceGeneralConfiguration'
import { schema, schemaDefault } from './schema'

import type { Schema } from './schema'

export const FormContainer = (): React.JSX.Element => {
  const { formId, general, loading, setTouched, setValid } = useContext(DefaultsContext)
  const { workspaceId } = useWorkspaceParam()
  const { errors: apiErrors, update } = useUpdateWorkspaceGeneralConfiguration()

  if (!general?.workspaceGeneralConfiguration) {
    throw Error('workspaceGeneralConfiguration should exists at this point')
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault({
        workspaceGeneralConfiguration: general.workspaceGeneralConfiguration,
        workspaceId,
      })}
    >
      {() => <Form />}
    </FormProvider>
  )
}
